import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function CTASubscribe() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const formData = new FormData(form);
      formData.delete('phone_alt');
      const response = await fetch('https://readdy.ai/api/form/d9rc8hvnahb7382ovkfg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注，我们会定期发送家庭关系指南到你的邮箱。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试。';
        setStatus('error');
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试。');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          {t('home.subscribeTitle')}
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8">
          {t('home.subscribeSubtitle')}
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('home.subscribePlaceholder')}
            required
            className="flex-1 px-5 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-white px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            {status === 'loading' ? '提交中...' : t('home.subscribeButton')}
          </button>
        </form>

        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-secondary-700' : 'text-accent-600'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}